var _a;
import React from 'react';
import classnames from 'classnames';
import FacebookIcon from '../Icons/Facebook';
import InstagramIcon from '../Icons/Instagram';
import TwitterIcon from '../Icons/Twitter';
import TumblrIcon from '../Icons/Tumblr';
import PatreonIcon from '../Icons/Patreon';
import EtsyIcon from '../Icons/Etsy';
import BehanceIcon from '../Icons/Behance';
import DribbbleIcon from '../Icons/Dribbble';
import YouTubeIcon from '../Icons/YouTube';
import VimeoIcon from '../Icons/Vimeo';
import TwitchIcon from '../Icons/Twitch';
import LinkedInIcon from '../Icons/LinkedIn';
import PinterestIcon from '../Icons/Pinterest';
import FlickrIcon from '../Icons/Flickr';
import { useTranslation } from 'react-i18next';
import s from './SocialIcon.scss';
export var SocialNetwork;
(function (SocialNetwork) {
    SocialNetwork[SocialNetwork["BEHANCE"] = 1] = "BEHANCE";
    SocialNetwork[SocialNetwork["DRIBBLE"] = 2] = "DRIBBLE";
    SocialNetwork[SocialNetwork["ETSY"] = 3] = "ETSY";
    SocialNetwork[SocialNetwork["FACEBOOK"] = 4] = "FACEBOOK";
    SocialNetwork[SocialNetwork["FLICKR"] = 5] = "FLICKR";
    SocialNetwork[SocialNetwork["INSTAGRAM"] = 7] = "INSTAGRAM";
    SocialNetwork[SocialNetwork["LINKEDIN"] = 8] = "LINKEDIN";
    SocialNetwork[SocialNetwork["PATREON"] = 9] = "PATREON";
    SocialNetwork[SocialNetwork["PINTEREST"] = 10] = "PINTEREST";
    SocialNetwork[SocialNetwork["TUMBLR"] = 11] = "TUMBLR";
    SocialNetwork[SocialNetwork["TWITCH"] = 12] = "TWITCH";
    SocialNetwork[SocialNetwork["TWITTER"] = 13] = "TWITTER";
    SocialNetwork[SocialNetwork["VIMEO"] = 14] = "VIMEO";
    SocialNetwork[SocialNetwork["YOUTUBE"] = 15] = "YOUTUBE";
})(SocialNetwork || (SocialNetwork = {}));
var socialNetworks = (_a = {},
    _a[SocialNetwork.BEHANCE] = {
        titleKey: 'social.on.behance',
        altTitleKey: 'social.behance',
        icon: BehanceIcon,
        name: 'behance',
    },
    _a[SocialNetwork.DRIBBLE] = {
        titleKey: 'social.on.dribbble',
        altTitleKey: 'social.dribbble',
        icon: DribbbleIcon,
        name: 'dribbble',
    },
    _a[SocialNetwork.ETSY] = {
        titleKey: 'social.on.etsy',
        altTitleKey: 'social.etsy',
        icon: EtsyIcon,
        name: 'etsy',
    },
    _a[SocialNetwork.FACEBOOK] = {
        titleKey: 'social.on.facebook',
        altTitleKey: 'social.facebook',
        icon: FacebookIcon,
        name: 'facebook',
    },
    _a[SocialNetwork.FLICKR] = {
        titleKey: 'social.on.flickr',
        altTitleKey: 'social.flickr',
        icon: FlickrIcon,
        name: 'flickr',
    },
    _a[SocialNetwork.INSTAGRAM] = {
        titleKey: 'social.on.instagram',
        altTitleKey: 'social.instagram',
        icon: InstagramIcon,
        name: 'instagram',
    },
    _a[SocialNetwork.LINKEDIN] = {
        titleKey: 'social.on.linkedin',
        altTitleKey: 'social.linkedin',
        icon: LinkedInIcon,
        name: 'linkedin',
    },
    _a[SocialNetwork.PATREON] = {
        titleKey: 'social.on.patreon',
        altTitleKey: 'social.patreon',
        icon: PatreonIcon,
        name: 'patreon',
    },
    _a[SocialNetwork.PINTEREST] = {
        titleKey: 'social.on.pinterest',
        altTitleKey: 'social.pinterest',
        icon: PinterestIcon,
        name: 'pinterest',
    },
    _a[SocialNetwork.TWITCH] = {
        titleKey: 'social.on.twitch',
        altTitleKey: 'social.twitch',
        icon: TwitchIcon,
        name: 'twitch',
    },
    _a[SocialNetwork.TWITTER] = {
        titleKey: 'social.on.twitter',
        altTitleKey: 'social.twitter',
        icon: TwitterIcon,
        name: 'twitter',
    },
    _a[SocialNetwork.TUMBLR] = {
        titleKey: 'social.on.tumblr',
        altTitleKey: 'social.tumblr',
        icon: TumblrIcon,
        name: 'tumblr',
    },
    _a[SocialNetwork.YOUTUBE] = {
        titleKey: 'social.on.youtube',
        altTitleKey: 'social.youtube',
        icon: YouTubeIcon,
        name: 'youtube',
    },
    _a[SocialNetwork.VIMEO] = {
        titleKey: 'social.on.vimeo',
        altTitleKey: 'social.vimeo',
        icon: VimeoIcon,
        name: 'vimeo',
    },
    _a);
export var SocialIcon = function (_a) {
    var networkId = _a.network, username = _a.username, className = _a.className;
    var t = useTranslation().t;
    var _b = socialNetworks[networkId], Icon = _b.icon, titleKey = _b.titleKey, altTitleKey = _b.altTitleKey;
    var title = username ? t(titleKey, { username: username }) : t(altTitleKey);
    return (React.createElement("span", { title: title, "aria-label": title, className: classnames(s['root'], className) },
        React.createElement(Icon, null)));
};
SocialIcon.displayName = 'SocialIcon';
export default SocialIcon;
//# sourceMappingURL=SocialIcon.js.map